module.exports = __webpack_public_path__ + "img/Picture2.3a5cfb8b.jpg";